/**
 * Plane annotation geometry properties — registration and getters.
 *
 * Properties registered here:
 * - plane_position (COORDINATE, PROJECT_GLOBAL) — {x, y, z}
 * - plane_normal (COORDINATE, PROJECT_GLOBAL) — {x, y, z}
 * - plane_radius (FLOAT, PROJECT_GLOBAL) — number
 */

import { PropertyType, PropertyValueType } from '../../types';
import { propertyRegistry } from '../../PropertyRegistry';
import { ReactiveProperty } from '../../reactive/ReactiveProperty';
import { getGlobalPropertyService } from '../../reactive/globalPropertyService';

export function registerPlaneGeometryProperties() {
  if (!propertyRegistry.isRegistered('plane_position')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'plane_position',
      name: 'Position',
      valueType: PropertyValueType.COORDINATE,
      defaultValue: { x: 0, y: 0, z: 0 },
      annotationTypes: [],
    });
  }

  if (!propertyRegistry.isRegistered('plane_normal')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'plane_normal',
      name: 'Normal',
      valueType: PropertyValueType.COORDINATE,
      defaultValue: { x: 0, y: 0, z: 1 },
      annotationTypes: [],
    });
  }

  if (!propertyRegistry.isRegistered('plane_radius')) {
    propertyRegistry.register({
      type: PropertyType.PROJECT_GLOBAL,
      identifier: 'plane_radius',
      name: 'Radius',
      valueType: PropertyValueType.FLOAT,
      defaultValue: 1.0,
      annotationTypes: [],
    });
  }
}

registerPlaneGeometryProperties();

type Coordinate = { x: number; y: number; z: number };

export function getPlanePositionProperty(annotationId: string): ReactiveProperty<Coordinate> {
  const service = getGlobalPropertyService();
  return service.getProperty('plane_position', annotationId, PropertyType.PROJECT_GLOBAL) as ReactiveProperty<Coordinate>;
}

export function getPlaneNormalProperty(annotationId: string): ReactiveProperty<Coordinate> {
  const service = getGlobalPropertyService();
  return service.getProperty('plane_normal', annotationId, PropertyType.PROJECT_GLOBAL) as ReactiveProperty<Coordinate>;
}

export function getPlaneRadiusProperty(annotationId: string): ReactiveProperty<number> {
  const service = getGlobalPropertyService();
  return service.getProperty('plane_radius', annotationId, PropertyType.PROJECT_GLOBAL) as ReactiveProperty<number>;
}
